import { Key } from 'react'

import {
  FeedProductInterface,
  OrderProductModel,
  StockedProduct,
} from '@/types'

type AnyProduct = StockedProduct | FeedProductInterface | OrderProductModel

export default function getProductKey(record: AnyProduct): Key {
  const code = record.nomenclatureDto?.code ?? ''

  if ('suppliersStock' in record && record.suppliersStock?.length > 0) {
    const supplierStock = record.suppliersStock[0]
    const stockItem = supplierStock.stock?.[0]

    const storeId = stockItem?.storeShortModel?.id || supplierStock.supplierId

    const storeCode = stockItem?.storeShortModel?.code
    const route =
      stockItem?.route ??
      ('prices' in supplierStock ? supplierStock.prices[0]?.route : undefined)
    const routeKey = route ? route.join(',') : ''

    if (storeCode !== undefined) {
      return `${code} ${storeId} ${storeCode} ${routeKey}`.trim()
    }
    return `${code} ${storeId} ${routeKey}`.trim()
  }

  if (
    'storeShortModel' in record &&
    'route' in record &&
    !('suppliersStock' in record)
  ) {
    const flatProd = record as OrderProductModel
    const store = flatProd.storeShortModel
    const routeKey = flatProd.route?.length ? flatProd.route.join(',') : ''
    if (store?.code !== undefined) {
      return `${code} ${store.id} ${store.code} ${routeKey}`.trim()
    }
    return String(code)
  }

  return String(code)
}
